<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-I">To Claudia, Olivia, and Wesley, with love.</span></p>
<p class="DED"><span class="ePub-I">I couldn’t do it without you.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0d81c6aa